// extracted by mini-css-extract-plugin
export default {"banner":"dw1ws","text":"AHUch","button":"qO3Vj","iconContainer":"B_Ome","icon":"IH57Z","textKz":"uhih9"};